import { Utils } from "../utils/utils";

export const CookieService = {

setCookie: (value, key, days) =>  {
    var date = new Date();
    const sanitizedKey = Utils.sanitizeCookieName(key);
    // Default at 365 days.
    days = days || 1;

    // Get unix milliseconds at current time plus number of days
    date.setTime(+ date + (days * 86400000)); //24 * 60 * 60 * 1000

    window.document.cookie = sanitizedKey + "=" + value + "; expires=" + date.toGMTString() + "; path=/";

    return value;
},

getCookie: (key) => {
    let name = key + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  },

  /**
   * Deletes all cookies.
   * We using window so user can only read cookies.
   */
  deleteAllCookie: () => {
    const cookies = window.document.cookie.split(";");

    for (let cookie of cookies) {
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();
        const sanitizedName = Utils.sanitizeCookieName(name);
        if (sanitizedName && sanitizedName === name) {
            window.document.cookie = sanitizedName + "=; Max-Age=0; path=/";
        }
    }
  }

}